// imageHelper.js

const images = (face) => {
    if (face) {
        const regex = /"(.*?)"/;
        const result = face.match(regex);
        // 输出提取的字符
        if (result && result[1]) {
            if (result[1].startsWith('http')) {
                return result[1];
            } else {
                if (result[1].startsWith('/')) {
                    return 'http://www.daomenkou.cn' + result[1];
                } else {
                    return 'http://www.daomenkou.cn/' + result[1];
                }
            }
        } else {
            console.log('未找到匹配的字符串');
            if (face.startsWith('http')) {
                return face;
            } else {
                return 'http://www.daomenkou.cn/' + face;
            }
        }
    } else {
        return require('@/assets/shop/morentx.png');
    }
};

export default images;